
import { useEffect } from "react";
import { CargandoMedio, TablaListadoVehiculos } from "../../components";
import { DisenioPaginas } from "../../layout";
import { useVehiculoStore } from "../../../store";






export const ListadoVehiculos = () => {


  const { vehiculos, startListadoVehiculos, isLoadingvehiculo } = useVehiculoStore();


  useEffect(() => {
    startListadoVehiculos();
  }, [])


  return (

      <DisenioPaginas titulo="Listado de Vehiculos" url='vehiculo'>
          {(isLoadingvehiculo)
              ? <CargandoMedio titulo="Cargando Vehiculo..." />
              : <TablaListadoVehiculos data={vehiculos} />
          }
      </DisenioPaginas>
    )
}
